export const FETCH_CRASH_EVENT = 'FETCH_CRASH_EVENT';

export const FETCH_CRASH_EVENT_IS_PENDING = 'FETCH_CRASH_EVENT_IS_PENDING';

export const FETCH_CRASH_EVENT_IS_ERROR = 'FETCH_CRASH_EVENT_IS_ERROR';

export const CLEAN_ERROR = 'CLEAR_ERROR_CRASH_EVENT';
